export default __webpack_public_path__ + "static/media/favicon-dark.0e9dcdc7.svg";